import Cookie from "js-cookie";
import { COOKIE_DOMAIN } from '../config/secrets.json';

export const setCookie = (key, value) => {
	if (process.browser) {
		Cookie.set(key, value, {
			domain: COOKIE_DOMAIN,
			expires: 1,
			path: "/"
		});
	}
};

export const removeCookie = key => {
	if (process.browser) {
		Cookie.remove(key, {
			domain: COOKIE_DOMAIN,
			path: "/"
		});
	}
};

export const getCookie = (key, req) => {
	return process.browser
		? getCookieFromBrowser(key)
		: getCookieFromServer(key, req);
};

const getCookieFromBrowser = key => {
	return Cookie.get(key);
};

const getCookieFromServer = (key, req) => {
	if (!req.headers.cookie) {
		return undefined;
	}
	const rawCookie = req.headers.cookie
		.split(";")
		.find(c => c.trim().startsWith(`${key}=`));
	if (!rawCookie) {
		return undefined;
	}
	return rawCookie.split("=")[1];
};



// WEBPACK FOOTER //
// ./src/lib/session.js